import React from "react";
import { Button, Typography } from "../../ecosystem";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";

const VideoVisitLaunchBtn = ({
    props,
    appointmentDetails,
    disabled,
    videoVisitLinks,
    isMobile,
    isSDCVisit,
    roomClosingTime,
}) => {

    const handleVideoVisitLaunch = () => {
        logUI("MBHWeb.Dashboard.AppointmentTile.LaunchVideoVisit.Click", new Date(), Tools.getURLPath());
        if (videoVisitLinks && appointmentDetails && appointmentDetails.csnIdOfAppointment && appointmentDetails.csnIdOfAppointment in videoVisitLinks) {
            let videoVisitLink = videoVisitLinks[appointmentDetails.csnIdOfAppointment] && videoVisitLinks[appointmentDetails.csnIdOfAppointment].url ?
                videoVisitLinks[appointmentDetails.csnIdOfAppointment].url : null;
            window.open(videoVisitLink, '_blank');
        }
        else {
            const patientExternalId = appointmentDetails && appointmentDetails.patientExternalId ? appointmentDetails.patientExternalId : null;
            props.history.push({ pathname: "/videovisit/" + appointmentDetails.csnIdOfAppointment, state: { Id: patientExternalId } });
        }
    }


    return (<div className={"video-visit-launch-btn"}>
        <div className="video-visit-launch-btn__button">
            <Button
                type="primary"
                icon="video-visit"
                fluid={isMobile ? true : false}
                disabled={disabled}
                onClick={handleVideoVisitLaunch}
            >
                Launch Video Visit
            </Button>
        </div>
        {isSDCVisit && roomClosingTime && !disabled &&
            <div className="video-visit-launch-btn__msg">
                <Typography
                    type="meta-01"
                    tag="div"
                    textAlign="center"
                    color="$color-secondary-a2"
                >
                    {"*Room entry closes at " + roomClosingTime}
                </Typography>
            </div>
        }
    </div>);
}

export default VideoVisitLaunchBtn;
